import http from '../utils/http';

const IMPERSONATE_USER = '/user/impersonate';
const SUPERVISOR_SHIFTS_CALENDAR = '/supervisor/shifts/calendar';

/**
 * get userinfo and token of impersonating user
 * @param {number} supervisorId impersonating userid
 */
export const getImpersonateUserToken = (supervisorId) => http.get(`${IMPERSONATE_USER}/${supervisorId}`);

export const fetchCalendarDayWithFillStatus = async () => {
	const { data } = await http.get(SUPERVISOR_SHIFTS_CALENDAR);
	return data;
};
